import { Box, Stack, } from '@chakra-ui/react'
import BranchCard from '../../Card/index'
import { IBranch } from '@/_types'
import { SegmentedControl } from '@/components/ui/segmented-control'
import { BRAND_NAMES, FEATURED_BRANDS } from '@/_utils/Constants'
import { Dispatch, SetStateAction } from 'react'

export default function Mobile({ data, activeBrandId, setActiveBrandId }: {
  data: IBranch[],
  activeBrandId: string | undefined;
  setActiveBrandId: Dispatch<SetStateAction<string>>
}) {
  return (
    <>
      <Box
        px={4} mt={2} mb={4} maxW="100vw" overflowX="auto" overflowY="visible" h='fit-content'>
        <SegmentedControl
          size='sm'
          height='36px'
          variant='chip'
          fontWeight={600}
          value={activeBrandId}
          onValueChange={(e) => { if (e.value) setActiveBrandId(e.value) }}
          items={Object.entries(BRAND_NAMES)
            // Hide Yoko Pizza
            .filter(([id]) => id !== FEATURED_BRANDS.yokopizza)
            ?.map(([id, name]) => ({
            label: name,
            value: id,
          }))}
        />
      </Box>
      <Stack px={4} pb={10}>
        {data?.map((item) => (
          <BranchCard key={item.id} data={item} activeShipperId={activeBrandId || ""} />
        ))}
      </Stack>
    </>
  )
}


{/* <Tabs.Root defaultValue='list' rounded={12} variant='plain'>
<Container my={4}>
  <Tabs.List
    p={1}
    w={'full'}
    rounded={12}
    bg='background'
    color={'text.muted'}
  >
    <Tabs.Trigger
      _selected={{
        color: 'text',
      }}
      w={'full'}
      value='list'
      color={'text.muted'}
      justifyContent={'center'}
    >
      {t('list')}
    </Tabs.Trigger>
    <Tabs.Trigger
      _selected={{
        color: 'text',
      }}
      w={'full'}
      value='map'
      color={'text.muted'}
      justifyContent={'center'}
    >
      {t('map')}
    </Tabs.Trigger>
    <Tabs.Indicator bgColor={'background.card'} rounded={12} />
  </Tabs.List>
</Container>
<Tabs.Content value='list'>
  <Stack separator={<StackSeparator />}>
    {data?.map((item: IBranch) => (
      <BranchCard key={item.id} data={item} />
    ))}
  </Stack>
</Tabs.Content>
<Tabs.Content
  value='map'
  display='flex'
  position={'fixed'}
  flexDir='column'
  height={'calc(100vh - 150px)'}
>
  <BranchesMap data={data} onClose={() => {}} />
</Tabs.Content>
</Tabs.Root> */}